import { useCallback } from 'react';
import { DataGrid } from 'devextreme-react/data-grid';

export const useStateStoring = <TData>(
  stateStoringKey: string | undefined,
  innerGridRef: React.MutableRefObject<DataGrid<TData, keyof TData> | undefined>,
) => {
  const normalizeState = (state: any) => {
    if (Array.isArray(state?.columns)) {
      state.columns.forEach((col: any) => {
        delete col.sortOrder;
        delete col.sortIndex;
        delete col.filterValues;
        delete col.selectedFilterOperation;
      });
    }

    delete state.searchText;
    delete state.selectedRowKeys;

    state.pageSize = state.pageSize != 0 ? state.pageSize : 50;

    return state;
  };

  const saveState = useCallback(
    (state: any) => {
      innerGridRef?.current?.instance.option('paging.pageIndex', state.pageIndex);

      if (stateStoringKey) {
        localStorage.setItem(stateStoringKey, JSON.stringify(state));
      } // if
    },
    [stateStoringKey],
  );

  const loadState = useCallback(() => {
    if (stateStoringKey) {
      const item = localStorage.getItem(stateStoringKey);

      if (!item) return null;

      return normalizeState(JSON.parse(item));
    } // if
  }, [stateStoringKey]);

  return {
    saveState,
    loadState,
  };
};
